import React, { useState } from 'react'
import { IProps } from './index'
import { Text } from 'marketing-site/src/library/elements/Text'
import { mq } from 'marketing-site/src/library/utils'
import NewPlayIconDesktop from '../../../library/images/NewPlayIconDesktop.svg'
import NewPlayIconMobile from '../../../library/images/NewPlayIconMobile.svg'

export function Hero(props: IProps) {
  const [playing, setPlaying] = useState(false)
  function handlePlay() {
    setPlaying(true)
    // @ts-ignore
    window.Wistia.api(props.wistiaId).play()
  }

  return (
    <div className="demo__hero-wrap">
      <div className="demo__hero">
        <div className="demo__hero-inner">
          <h1>
            <Text size="heading">{props.title}</Text>
          </h1>

          <div className="demo__video-wrap">
            <div className="demo__video">
              <iframe
                src={`https://fast.wistia.net/embed/iframe/${props.wistiaId}?videoFoam=true&autoPlay=false&videoQuality=hd-only`}
                title={`Video on ${props.title}`}
                name="wistia_embed"
                frameBorder="0"
                allowFullScreen
              ></iframe>
              <div
                className={`demo__thumb ${playing && 'demo__thumb-hidden'}`}
                role="button"
                onClick={handlePlay}
                onKeyPress={handlePlay}
                tabIndex={0}
              >
                <div className="demo__icon"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .demo__hero-wrap {
            display: grid;
            grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;
            padding-bottom: 70px;
            padding: 60px 0 0;
            position: relative;
            color: ${props.color || '#000000'};

            &:before {
              content: '';
              background: ${props.background};
              position: absolute;
              z-index: -1;
              top: 0;
              left: 0;
              right: 0;
              bottom: 80px;
            }
          }

          .demo__hero {
            grid-column: content;
            text-align: center;
          }

          h1 {
            max-width: 740px;
            margin: 0 auto;
          }

          .demo__video-wrap {
            max-width: 770px;
            margin: 60px auto 0;
            position: relative;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 6px 20px 0px rgba(0, 0, 0, 0.1);
          }

          .demo__video {
            width: 100%;
            overflow: hidden;
            height: 0;
            padding-bottom: 56.25%;
            position: relative;

            .demo__thumb,
            iframe {
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              .demo__icon {
                border-radius: 50%;
                box-shadow: 0 6px 20px 0px #757575;
                background-image: url(${NewPlayIconMobile});
                width: 68px;
                height: 68px;
              }
            }
          }

          .demo__thumb {
            background: url(${props.wistia?.thumbnail});
            background-size: cover;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 10;
            opacity: 1;
            transition: opacity 0.3s;
          }

          .demo__thumb-hidden {
            opacity: 0;
            pointer-events: none;
          }

          @media (${mq.tablet}) {
            :global(main) {
              padding-top: 20px !important;
            }

            .demo__hero-wrap {
              padding-top: 100px;
            }

            .demo__video {
              .demo__thumb,
              iframe {
                .demo__icon {
                  background-image: url(${NewPlayIconDesktop});
                  width: 100px;
                  height: 100px;
                }
              }
            }
          }
        `}
      </style>
    </div>
  )
}
